export const AuctionInfo = ({ vehicle }) => {
  return (
    <span>
      {vehicle.auction?.slug || '-'}/{vehicle.orderIndex || '-'}
    </span>
  );
};
